<template>
  <div>
    <el-row :gutter="12">
      <el-col :span="table_span">
        <!-- 车辆监控查询表单 -->
        <el-form
        :model="search_form"
        label-width="100px"
        class="search_form"
        ref="search_form_cart"
        >
          <el-form-item label="车牌号" prop="cart_no">
            <el-input placeholder="输入车牌号" v-model="search_form.cart_no"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
            type="primary"
            icon="el-icon-search"
            class="operate_btn"
            @click="search_cart"
            >查询</el-button>
            <el-button
            icon="el-icon-close"
            class="operate_btn"
            @click="reset_cart"
            >重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 车辆监控列表 -->
        <el-table
        v-loading="list_loading"
        highlight-current-row
        :data="cart_data"
        border
        ref="cart_temp_list"
        @row-dblclick="db_temp_list"
        @select="one_selection"
        @select-all="handleSelectionChange"
        :row-key="get_row_keys"
        >
          <el-table-column
          type="selection"
          :reserve-selection="true"
          width="55"
          ></el-table-column>
          <el-table-column
          type="index"
          align="center"
          label="序号"
          width="100"
          ></el-table-column>
          <el-table-column
          prop="vehicleNo"
          label="车牌号"
          ></el-table-column>
        </el-table>
      </el-col>
      <el-col
      class="icon_cart_left"
      :span="1"
      :style="{height: map_height,lineHeight:map_height}">
        <i :class="cart_left_class"
        @click="hide_table"
        style="font-size: 20px;cursor: pointer;"></i>
      </el-col>
      <el-col :span="map_span" :style="{height: map_height}">
        <!-- 地图控件 -->
        <baidu-map
        id="amap"
        :center="center"
        :scroll-wheel-zoom="true"
        :zoom="zoom"
        @zoomend="zoomend"
        @moveend="moveend"
        @ready="handler">
          <bm-marker
          v-for="(item,index) in checked_option"
          :key="index"
          :position="{lng:item.lon,lat:item.lat}"
          :dragging="false"
          :zIndex="label_no==item.vehicleNo?2:0"
          >
            <bm-label
            :content="item.vehicleNo"
            @click="get_control(index)"
            :labelStyle="{color:label_no==item.vehicleNo?'red':'rgb(64, 158, 255)',
            cursor:'pointer',
            fontSize : '14px',
            border:'1px solid rgb(64, 158, 255)'}"
            :offset="{width: -5, height: -5}"/>
          </bm-marker>
          <bm-scale
          anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
          <bm-navigation
          anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
          <bm-control
          anchor="BMAP_ANCHOR_TOP_RIGHT"
          :offset="{width:5,height:5}"
          >
            <el-card style="width: 250px;">
              <div slot="header">
                <h2 class="control_h2">{{now_row.vehicleNo}}</h2>
              </div>
              <div class="control_content">
                <p>
                  <span>定位时间：</span>
                  <span>{{now_row.gpsTime}}</span>
                </p>
                <p>
                  <span>位置：</span>
                  <span>{{cart_address}}</span>
                </p>
                <p>
                  <span>温度：</span>
                  <span
                  v-for="(item,index) in now_row.tempData"
                  :key="index"
                  >{{index+1}}路：{{item.pointValue}}℃<br/></span>
                </p>
              </div>
            </el-card>
          </bm-control>
        </baidu-map>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default{
    data() {
      let that=this
      return{
        // 车辆监控查询表单
        search_form:{
          cart_no:''
        },
        //响应式布局
        table_span:7,
        map_span:16,
        el_flag:false,
        cart_left_class:'el-icon-caret-left',
        //车辆监控列表
        cart_data:[],
        //数据行
        now_row:{},
        //选中项
        checked_option:[],
        //车辆监控列表懒加载
        list_loading:false,
        //地图控件
        //地图初始化坐标
        BMap:null,
        center:{lng:0,lat:0},
        zoom:17,
        label_no:'',
        //车辆位置
        cart_address:'',
        //百度地图自适应高度
        map_height:600+'px'
      }
    },
    created() {

    },
    mounted() {

    },
    watch:{
      '$route'(to,from){
        if(to.name=='truck_detail'){
          if(this.$route.query.row){
            //获取实时温度列表
            this.get_cart_data('row')
          }else{
            //获取实时温度列表
            this.get_cart_data('load')
          }
        }
      }
    },
    methods:{
      //初始化地图控件
      handler(e){
        if(this.$route.query.row){
          //获取实时温度列表
          this.get_cart_data('row')
        }else{
          //获取实时温度列表
          this.get_cart_data('load')
        }
      },
      //隐藏车辆监控列表
      hide_table(){
        this.el_flag=!this.el_flag
        if(this.el_flag==true){
          this.table_span=0
          this.map_span=23
          this.cart_left_class='el-icon-caret-right'
        }else{
          this.table_span=7
          this.map_span=16
          this.cart_left_class='el-icon-caret-left'
        }
      },
      //获取车辆监控列表
      get_cart_data(load_status,row){
        this.list_loading=true
        this.$axios({
          method:'get',
          url:this.publicAjax.extra_path+'/middle/overView/driveDetail',
          params:{
            vehicleNo:this.search_form.cart_no
          }
        }).then(data=>{
          this.list_loading=false
          if(data.data.success==true){
            this.cart_data=data.data.data
            if(this.cart_data.length==0){
              return false
            }
            setTimeout(()=>{
              if(load_status=='load'){
                this.now_row=this.cart_data[0]
                this.center.lng=this.cart_data[0].lon
                this.center.lat=this.cart_data[0].lat
                this.label_no=this.cart_data[0].vehicleNo
                this.$refs.cart_temp_list.clearSelection()
                this.$nextTick(()=>{
                  this.$refs.cart_temp_list.toggleRowSelection(this.cart_data[0],true)
                })
                this.checked_option=[this.cart_data[0]]
              }else if(load_status=='row'){
                this.now_row=this.cart_data[this.$route.query.row.index]
                this.center.lng=this.cart_data[this.$route.query.row.index].lon
                this.center.lat=this.cart_data[this.$route.query.row.index].lat
                this.label_no=this.cart_data[this.$route.query.row.index].vehicleNo
                this.$refs.cart_temp_list.clearSelection()
                this.$nextTick(()=>{
                  this.$refs.cart_temp_list.toggleRowSelection(this.cart_data[this.$route.query.row.index],true)
                })
                this.checked_option=[this.cart_data[this.$route.query.row.index]]
              }
              //获取车辆地址信息
              this.get_cart_address()
            },300)
          }else{
            this.$message.warning(data.data.message)
          }
        })
      },
      //获取车辆地址信息
      get_cart_address(){
        let myGeo=new BMap.Geocoder({extensions_town: true})
        myGeo.getLocation(new BMap.Point(this.center.lng, this.center.lat),result=>{
          this.cart_address=result.address
        })
      },
      //车辆监控列表全选事件
      handleSelectionChange(val){
        this.checked_option=val
        if(this.checked_option.length==0){
          this.label_no=''
          this.now_row={}
          this.center.lng=''
          this.center.lat=''
        }else{
          this.label_no=this.cart_data[0].vehicleNo
          this.now_row=this.cart_data[0]
          this.center.lng=this.cart_data[0].lon
          this.center.lat=this.cart_data[0].lat
        }
        //获取车辆地址信息
        this.get_cart_address()
      },
      //获取选中行
      get_row_keys(row){
        return row.vehicleNo
      },
      //车辆监控列表单选事件
      one_selection(val,row){
        this.checked_option=val
        if(this.checked_option.length==0){
          this.label_no=''
          this.now_row={}
          this.center.lng=''
          this.center.lat=''
        }else{
          this.checked_option.forEach(item=>{
            if(row.vehicleNo==item.vehicleNo){
              this.label_no=item.vehicleNo
              this.now_row=item
              this.center.lng=item.lon
              this.center.lat=item.lat
            }else{
              this.label_no=this.checked_option[0].vehicleNo
              this.now_row=this.checked_option[0]
              this.center.lng=this.checked_option[0].lon
              this.center.lat=this.checked_option[0].lat
            }
          })
        }
        //获取车辆监控列表
        this.get_cart_data()
      },
      //车辆监控列表数据行双击事件
      db_temp_list(row,column,event){
        this.label_no=row.vehicleNo
        this.now_row=row
        this.center.lng=row.lon
        this.center.lat=row.lat
        //获取车辆地址信息
        this.get_cart_address()
      },
      //查询车辆监控列表
      search_cart(){
        //获取车辆监控列表
        this.get_cart_data('load')
      },
      //重置车辆监控列表
      reset_cart(){
        this.search_form.cart_no=''
        this.$refs['search_form_cart'].resetFields()
        //获取车辆监控列表
        this.get_cart_data('load')
      },
      //地图控件覆盖物点击事件
      get_control(index){
        this.label_no=this.checked_option[index].vehicleNo
        this.now_row=this.checked_option[index]
        this.center.lng=this.now_row.lon
        this.center.lat=this.now_row.lat
        //获取车辆地址信息
        this.get_cart_address()
      },
      //地图控件更改缩放级别
      zoomend(e){
        this.zoom=e.target.getZoom()
      },
      //地图控件移动结束事件
      moveend(e){

      }
    }
  }
</script>

<style scoped>
  /* .search_form .el-form-item{
    width: 49%;
    display: inline-block;
  } */
  #amap{
    width: 100%;
    height: 100%;
  }
  .icon_cart_left{
    text-align: center;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .control_h2{
    color: rgb(64, 158, 255);
  }
  .control_content p{
    margin-bottom: 10px;
  }
  .control_content p>span{
    color: darkgray;
    display: inline-block;
    width: 100%;
    font-weight: 600;
  }
  .control_content p>span:nth-child(1){
    color: #303133;
    width: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/cold/truck_detail.vue